module.exports = __webpack_public_path__ + "img/0Q3B8790-7_H_BlackMatted_MockedUp.ea2fae2b.jpg";